import { render, staticRenderFns } from "./SkillsList.vue?vue&type=template&id=5f4ea774&scoped=true&"
import script from "./SkillsList.vue?vue&type=script&lang=js&"
export * from "./SkillsList.vue?vue&type=script&lang=js&"
import style0 from "./SkillsList.vue?vue&type=style&index=0&id=5f4ea774&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4ea774",
  null
  
)

export default component.exports